export class ConfirmationDialogController {
  /* @ngInject */
  constructor($mdDialog, firstWarningText, secondWarningText, resetScreeningRequiredValues, disableScreeningRequiredValues) {
    this.$mdDialog = $mdDialog;
    this.firstWarningText = firstWarningText;
    this.secondWarningText = secondWarningText;
    this.resetScreeningRequiredValues = resetScreeningRequiredValues;
    this.disableScreeningRequiredValues = disableScreeningRequiredValues;
  }

  confirm() {
    this.disableScreeningRequiredValues();
    this.$mdDialog.hide();
  }

  cancel() {
    this.resetScreeningRequiredValues();
    this.$mdDialog.cancel();
  }
}
